// Pure helpers for CplexAdminPage. Kept in a .ts sibling per the
// project's react-refresh / only-export-components rule.

import type { CplexRunState } from '../services/cplex';

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function isTerminalState(state: CplexRunState): boolean {
  return state === 'optimal' || state === 'infeasible' || state === 'error';
}

export function stateLabel(state: CplexRunState): string {
  const labels: Record<CplexRunState, string> = {
    queued: 'Queued',
    uploading: 'Uploading',
    dispatching: 'Dispatching',
    solving: 'Solving',
    optimal: 'Optimal',
    infeasible: 'Infeasible',
    error: 'Error',
  };
  return labels[state];
}
